import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

// const getTokenFromLocalStorage = localStorage.get("user")
//   ? JSON.parse(localStorage.getItem("user"))
//   : null;

const login = async (user) => {
  try {
    // Sanitize input to prevent injection attacks
    const sanitizedUser = {
      email: user.email.trim().toLowerCase(),
      password: user.password,
      recaptchaToken: user.recaptchaToken // Include reCAPTCHA token
    };
    
    const response = await axios.post(`${base_url}user/admin-login`, sanitizedUser);
    return response.data;
  } catch (error) {
    // Re-throw the error so it can be handled by the calling function
    throw error;
  }
};

const getOrders = async (data) => {
  const response = await axios.get(`${base_url}user/getallorders`, data);

  return response.data;
};

const getOrder = async (id) => {
  const response = await axios.get(
    `${base_url}user/getaOrder/${id}`,
    config
  );

  return response.data;
};

const updateOrder = async (data) => {
  const response = await axios.put(
    `${base_url}user/updateOrder/${data.id}`,
    { status: data.status },
    config
  );

  return response.data;
};

// Function to send order confirmation email with tracking link and invoice
const sendOrderConfirmationEmail = async (data) => {
  const response = await axios.post(
    `${base_url}user/order/${data.orderId}/send-confirmation`,
    { awbNumber: data.awbNumber },
    config
  );

  return response.data;
};

// Function to download invoice
const downloadInvoice = async (orderId) => {
  const response = await axios.get(
    `${base_url}user/order/${orderId}/invoice`,
    {
      ...config,
      responseType: 'blob'
    }
  );

  return response.data;
};

const getMonthlyOrders = async (data) => {
  const response = await axios.get(
    `${base_url}user/getMonthWiseOrderIncome`,

    data
  );

  return response.data;
};

const getYearlyStats = async (data) => {
  const response = await axios.get(
    `${base_url}user/getyearlyorders`,

    data
  );

  return response.data;
};

const authService = {
  login,
  getOrders,
  getOrder,
  getMonthlyOrders,
  getYearlyStats,
  updateOrder,
  sendOrderConfirmationEmail,
  downloadInvoice,
};

export default authService;